
import { Component, Vue } from 'vue-property-decorator'

/**
 * パネル枠
 */
@Component
export default class PanelFrame extends Vue {
  /**
   * クリックイベントの発火を親コンポーネントに通知する
   *
   * @param event イベントオブジェクト
   */
  private clickEvent(event: Event): void {
    this.$emit('click', event)
  }
}
